"use client"

import { BuyerHome } from "@/views/buyer";
import { Loading } from '@repo/ui';
import { useRedirecting } from '@repo/utils';

export const dynamic = 'force-dynamic';

export default function Home() {
  const { isRedirecting } = useRedirecting();

  if (isRedirecting) {
    return <Loading />;
  }
  
  return <BuyerHome />;
}
